/** Formatos de fecha, importe y porcentaje en español. */

/** `2026-10-13` → `13/10/2026`. Sin pasar por Date: no le afecta la zona horaria. */
export function fmtDate(day: string | null | undefined): string {
  if (!day) return '—';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(day);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : day;
}

/** Instante ISO → `13/10/2026 14:05` en hora de Madrid. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('es-ES', {
    timeZone: 'Europe/Madrid',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function fmtMoney(value: number | null | undefined, currency = 'EUR'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  try {
    return value.toLocaleString('es-ES', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 4 });
  } catch {
    return `${value.toLocaleString('es-ES', { minimumFractionDigits: 2 })} ${currency}`;
  }
}

export function fmtNumber(value: number | null | undefined, decimals = 0): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString('es-ES', { minimumFractionDigits: decimals, maximumFractionDigits: Math.max(decimals, 3) });
}

export function fmtPct(value: number | null | undefined, decimals = 1): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toLocaleString('es-ES', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} %`;
}

/** Hoy en Madrid como `YYYY-MM-DD`. */
export function todayDay(): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  return parts;
}

/** Días de `a` a `b` (b − a), ambos `YYYY-MM-DD`. */
export function daysBetween(a: string, b: string): number {
  const [ay, am, ad] = a.split('-').map(Number) as [number, number, number];
  const [by, bm, bd] = b.split('-').map(Number) as [number, number, number];
  return Math.round((Date.UTC(by, bm - 1, bd) - Date.UTC(ay, am - 1, ad)) / 86_400_000);
}

/** «hace 3 días», «dentro de 5 días», «hoy». */
export function relDays(day: string | null | undefined): string {
  if (!day) return '';
  const d = daysBetween(todayDay(), day.slice(0, 10));
  if (d === 0) return 'hoy';
  if (d === 1) return 'mañana';
  if (d === -1) return 'ayer';
  return d > 0 ? `dentro de ${d} días` : `hace ${-d} días`;
}
